import React, { FC, useState } from 'react';
import * as Text from '../Text';
import styled from 'styled-components';
import { Colors } from '../../../styles/colors';
import { Icon } from '../Icon';
import { FlexboxVertical } from '../Layout';

const ProductCategorySectionWrapper = styled.div<{ clickable?: boolean }>`
	padding: 2rem 1.5rem;
	position: relative;
	z-index: 0;
	
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: space-between;
	
	margin-top: 2rem;
	&:first-child {
		margin-top: 0;	
	}
	
	cursor: ${({ clickable = false }) => clickable ? 'pointer' : 'default'};
`;

const ProductCategoryItemImage = styled.img`
	position: absolute;
	z-index: -1;
	bottom: 0;
	right: 3.5rem;
	width: 60%;
	height: 100%;
	object-fit: contain;
	object-position: bottom right;
`;

const TextWrapper = styled(FlexboxVertical)`
  max-width: 45%;
`;

const SmallHeadline = styled(Text.Headline4)`
	color: ${Colors.grayDark};
	margin-bottom: .75rem;
`;

const SmallHeadlineText = styled(SmallHeadline)`
	font-weight: 400;
`;

const SmallHeadlineTextAccent = styled(SmallHeadlineText)<{ greenProduct: boolean }>`
	color: ${({ greenProduct = false }) => greenProduct ? Colors.secondary : Colors.primary};
`;

const IconWrapper = styled.div<{ active?: boolean }>`
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.grayDark};
  
  align-self: flex-end;
  margin-right: -1rem;
  margin-bottom: -2rem;
  
  & > * {
    transition: transform 300ms ease-out;
    transform: rotate(${({ active = false }) => active ? '0deg' : '-180deg'});
  }
`;

interface Props {
  sectionId: string;
  title: string;
  teaserText?: string;
  filteredCount?: number;
  count?: number;
  greenProduct?: boolean;
  imageUrl: string;
  active?: boolean;
  setActive?: (active: boolean) => void;
}
export const ProductCategorySectionHead: FC<Props> = ({
   title,
   imageUrl,
   teaserText,
   greenProduct = false,
   count = 0,
   filteredCount,
  ...props
}) => {
  const { active = false, setActive, } = props;

  return (
    <ProductCategorySectionWrapper data-section-id={`product-category-${props.sectionId}`} clickable={!!setActive} onClick={() => setActive && setActive(!active)}>
      <TextWrapper>
        <SmallHeadline>{ title }</SmallHeadline>
        {/*<SmallHeadlineTextAccent greenProduct={greenProduct}>{ teaserText }</SmallHeadlineTextAccent>*/}
        {/*<Text.TextDefault>{ filteredCount !== undefined && `${filteredCount} von ` }{ count } Produkt{ count !== 1 && 'e'}{ filteredCount !== undefined && count !== 1 && 'n' }</Text.TextDefault>*/}
        <SmallHeadlineTextAccent greenProduct={greenProduct}>{ filteredCount !== undefined && `${filteredCount} von ` }{ count } Produkt{ count !== 1 && 'e'}{ filteredCount !== undefined && count !== 1 && 'n' }</SmallHeadlineTextAccent>
      </TextWrapper>
      {
        setActive &&
        <IconWrapper active={active}>
          <Icon icon={'chevron'} size={24} />
        </IconWrapper>
      }
      <ProductCategoryItemImage alt='' src={imageUrl} />
    </ProductCategorySectionWrapper>
  )
}
